import type {
  PatchUsersRequest,
  PatchUsersResponse,
  UserInfo,
} from '@polyai/common/api/resources/userManagement/types';

import ENDPOINTS from 'api/endpoints';
import { doDelete, doGet, doPatch } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import { generateNextPath } from 'lib/routeHelper';

export const getUsers = (accountId: string) => {
  return doGet<UserInfo[]>(
    generateNextPath(ENDPOINTS.USER_MANAGEMENT, {
      accountId,
    }),
    LOGGER_TYPE.USER_MANAGEMENT,
    { params: { account_id: accountId } },
  );
};

export const patchUsers = ({
  accountId,
  body,
}: {
  accountId: string;
  body: Omit<PatchUsersRequest, 'account_id'>;
}) => {
  return doPatch<PatchUsersResponse>(
    generateNextPath(ENDPOINTS.USER_MANAGEMENT, {
      accountId,
    }),
    LOGGER_TYPE.USER_MANAGEMENT,
    {
      ...body,
      account_id: accountId,
    },
  );
};

export const deleteUsers = ({
  accountId,
  userEmails,
}: {
  accountId: string;
  userEmails: string[];
}) => {
  return doDelete(
    generateNextPath(ENDPOINTS.USER_MANAGEMENT, {
      accountId,
    }),
    LOGGER_TYPE.USER_MANAGEMENT,
    {
      users_email: userEmails,
      account_id: accountId,
    },
  );
};
